import { Component, Input } from '@angular/core';

import { SMS_REPLY_PATTERN } from '../constants';
import { DYNAMICFIELDS } from '../../constants';

@Component({
  selector: 'sms-warning',
  templateUrl: './sms-warning.component.html',
  standalone: false,
})
export class SmsWarningComponent {
  public parts: number;
  @Input() public ansiPartLength = 160;
  @Input() public nonAnsiPartLength = 70;
  @Input() set message(val) {
    this.parts = Math.ceil(this.getMessageLength(val) / this.getPartLength(val));
  }

  getMessageLength(str: string): number {
    const _str = typeof str === 'string' ? str : '';
    let len = _str.length;
    DYNAMICFIELDS.forEach((field) => {
      if (_str.indexOf(`{${field.name}}`) !== -1) {
        len += field.defaultLength - `{${field.name}}`.length;
      }
    });

    return len;
  }

  private getPartLength(message): number {
    return SMS_REPLY_PATTERN.test(message) ? this.ansiPartLength : this.nonAnsiPartLength;
  }
}
